import React, { useState } from "react";
import propTypes from "prop-types";

const list = [{ name: "loading...", id: 0 }];

const LabelInput = ({
  onChange,
  label,
  name,
  value = "",
  data = list,
  required = false,
  errorMsg = null,
  isError = true,
  disabled = false,
  noWrap = false,
  mtValue = false,
  width='100%'
}) => {
  const [isValue, setIsValue] = useState(value.length ? value : "");
  const [listData, setListData] = useState(data);
  const handleCheckboxChange = (checked) => {
    setIsValue(checked);
    if (onChange) onChange(checked);
  };
  return (
    <div className={(mtValue) ? 'full-width mt-v25' : 'full-width'}>
      <label className="label">
        <span className="label-v2">
          <input
            type="checkbox"
            name={name}
            onChange={(e) => handleCheckboxChange(e.target.checked)}
            className="mr-2"
            disabled={disabled ? "disabled" : ""}
            style={{width:width}}
          />
          <span className={(noWrap) ? 'noWrap' : ''}>{label}</span>
        </span>
      </label>
    </div>
  );
};

LabelInput.propTypes = {
  type: propTypes.oneOfType([propTypes.object, propTypes.string]),
  inputValue: propTypes.oneOfType([
    propTypes.object,
    propTypes.string,
    propTypes.number,
  ]),
  handleChange: propTypes.func,
  label: propTypes.oneOfType([propTypes.string, propTypes.object]),
  checked: propTypes.oneOfType([propTypes.string, propTypes.object]),
  errorMsg: propTypes.oneOfType([propTypes.string, propTypes.object]),
  name: propTypes.oneOfType([propTypes.string, propTypes.object]),
};

export default LabelInput;
